import { render, staticRenderFns } from "./TypeTable.vue?vue&type=template&id=200422ed&"
import script from "./TypeTable.vue?vue&type=script&lang=js&"
export * from "./TypeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports